import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import FinanceCategoryTable from "@features/admin/finance/category/components/FinanceCategoryTable";
import CreateFinanceCategoryModal from "@features/admin/finance/category/components/CreateFinanceCategoryModal";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useScopeId } from '@core/hooks/useRouteParamId';

const ManageFinanceCategories: React.FC = () => {
    const sid = useScopeId() ?? 0;
    const [showCreate, setShowCreate] = useState(false);
    const [refreshSignal, setRefreshSignal] = useState(0);

    return (
        <Container fluid className="py-4" data-testid="manage-finance-categories-container">
            <div
                className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4"
                data-testid="manage-finance-categories-header-row"
            >
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1" data-testid="manage-finance-categories-title">
                        Finance Categories
                    </h1>
                    <p className="text-muted mb-0" data-testid="manage-finance-categories-description">
                        Manage income categories, range bands, and distribution rules
                    </p>
                </div>
                {Number.isFinite(sid) && sid > 0 && (
                    <RequirePermission mode="section" action={ACTION_CODES.CREATE_CHURCH_FINANCIAL_CATEGORY} scopeType="NATION" scopeId={sid}>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            aria-label="Add Finance Category"
                            data-testid="add-finance-category-button"
                        >
                            <FiPlus className="me-2" />
                            New Category
                        </Button>
                    </RequirePermission>
                )}
            </div>

            <FinanceCategoryTable showPagination={true} refreshSignal={refreshSignal} />

            <CreateFinanceCategoryModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                onChanged={() => setRefreshSignal((s) => s + 1)}
            />
        </Container>
    );
};

export default ManageFinanceCategories;
